import { _CLAIMS_ADMIN } from '@/app/shared/constants/access.claims';

//================ MENU OPERATIONAL PLANNING =================
export const _CLAIMS_MENU_OPERATIONAL_PLANNING_R = [..._CLAIMS_ADMIN, 'MENU.OPERATIONAL_PLANNING-R'] as const;
export const _CLAIMS_MENU_OPERATIONAL_PLANNING_W = [..._CLAIMS_ADMIN, 'MENU.OPERATIONAL_PLANNING-W'] as const;

export const _CLAIMS_WFM_PLANNING_POLICIES_R = 'WFM-PLANNING-POLICIES-R' as const;
export const _CLAIMS_WFM_PLANNING_POLICIES_W = 'WFM-PLANNING-POLICIES-W' as const;

export const _CLAIMS_WFM_PRIORITIZATION_POLICIES_R = 'WFM-PRIORITIZATION-POLICIES-R' as const;
export const _CLAIMS_WFM_PRIORITIZATION_POLICIES_W = 'WFM-PRIORITIZATION-POLICIES-W' as const;

export const _CLAIMS_FIELD_TEAMS_R = 'FIELD-TEAMS-R' as const;
export const _CLAIMS_FIELD_TEAMS_W = 'FIELD-TEAMS-W' as const;

export const _CLAIMS_WFM_SCHEDULES_R = 'WFM-SCHEDULES-R' as const;
export const _CLAIMS_WFM_SCHEDULES_W = 'WFM-SCHEDULES-W' as const;

export const _CLAIMS_WFM_SERVICE_ASSIGNMENT_R = 'WFM-SERVICE-ASSIGNMENT-R' as const;
export const _CLAIMS_WFM_SERVICE_ASSIGNMENT_W = 'WFM-SERVICE-ASSIGNMENT-W' as const;

export const _CLAIMS_WFM_PLANNING_EXCEPTIONS_R = 'WFM-PLANNING-EXCEPTIONS-R' as const;
export const _CLAIMS_WFM_PLANNING_EXCEPTIONS_W = 'WFM-PLANNING-EXCEPTIONS-W' as const;

export const _CLAIMS_WFM_PLAN_CONSOLIDATION_R = 'WFM-PLAN-CONSOLIDATION-R' as const;
export const _CLAIMS_WFM_PLAN_CONSOLIDATION_W = 'WFM-PLAN-CONSOLIDATION-W' as const;

export const _CLAIMS_WFM_PLANNING_HISTORY_R = 'WFM-PLANNING-HISTORY-R' as const;
export const _CLAIMS_WFM_PLANNING_HISTORY_W = 'WFM-PLANNING-HISTORY-W' as const;